import { useState } from "react";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";

import Api from "Api";
import WeeklyData, { IDay } from "Components/WeeklyData";

import type { IStepProps } from ".";

interface IDayData {
  service_id: number;
  source_station_id: number;
  week_day: number;
  start_time?: string;
  end_time?: string;
}

export default function StationTiming({ data, setData }: IStepProps) {
  //   const [data, setData] = useState<IDay[]>([]);

  //   const saveTiming = useMutation({
  //     mutationFn: () => {
  //       const times: IDayData[] = [];
  //       data.forEach((day) => {
  //         day.times.forEach((time) => {
  //           times.push({
  //             service_id: modalData.serviceId,
  //             source_station_id: modalData.stationId,
  //             week_day: day.id,
  //             ...time,
  //           });
  //         });
  //       });

  //       return Api.post(`trip-plan/service-time`, { times }).then((res) => {
  //         toast.success("زمانبندی با موفقیت انجام شد");
  //         closeModal();
  //         setData([]);
  //       });
  //     },
  //   });

  return (
    <WeeklyData
      data={data?.eta}
      setData={(value) => setData("data", value)}
      text="زمانبندی"
      valueKey="eta"
      label="تا ایستگاه بعدی (دقیقه)"
      activeDays={data?.general?.working_days}
      selectStation={true}
    />
  );
}
